<title>{{ commonTypesDatalistsPage.htmlTitle }}</title>
<h2 [innerHtml]="this.commonTypesDatalistsPage.pageContentTitle"></h2>

<app-common-types-datalists-note-section [noteSections]="commonTypesDatalistsPage.noteSections"></app-common-types-datalists-note-section>

<app-common-types-datalists-accordion-section [accordionWithImage]="commonTypesDatalistsPage.schemaDataModelAccordians"></app-common-types-datalists-accordion-section>

<app-common-types-datalists-details-xml-section
  [commonTypesDataListsDetailsXMLSections]="commonTypesDatalistsPage.commonTypesDataListsDetailsXMLSections"
></app-common-types-datalists-details-xml-section>
